import React, { useEffect, useState } from 'react'
import './floating-button.scss'
import { StaticImage } from 'gatsby-plugin-image'
import useTotalSigns from '@/hooks/useTotalSigns'
const imageFLoatingButton = () => {
  return (
    <StaticImage
      src="../../../assets/images/floating-button.webp"
      alt="floating-button"
      className="f-floating-button-image"
      placeholder="blurred"
      height={174}
      width={183}
    />
  )
}
const FloatingButton = () => {
  const [totalPeople] = useTotalSigns()
  const [visible, setVisible] = useState(true)
  const handlerClose = () => {
    setVisible(false)
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const btn = document.querySelector('.f-floating-button .btn-close')
      btn.style.setProperty('visibility', 'visible')
    }, 5000)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [])
  if (!visible) {
    return null
  }
  return (
    <>
      <div className="f-floating-button">
        <a
          role="button"
          style={{ visibility: 'hidden' }}
          className="icon2-close btn-close"
          onClick={handlerClose}
        ></a>
        <div className="wrapper">
          <p>{totalPeople}</p>
          {imageFLoatingButton()}
        </div>
        <a href="#firma">Únete aquí</a>
      </div>
    </>
  )
}

export default FloatingButton
